<script>
import 'bulma/css/bulma.css'
import Router from '@/router/index.js'
import modalWindow from '@/components/ModalWindow'
import notifiedCard from './NotifiedCard'
import { getMyUserId, getMyUserData, signOutQnQ } from '@/api/FirebaseUserWrapper.js'
import { updateNotification } from '@/api/FirebaseViewWrapper.js'
import { sortArraybyCreatedAt } from '@/api/Utilities.js'
import { getNotificationData } from '@/api/NotificationUtilities.js'
import Store from '@/store/index.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getFirestore, collection, query, onSnapshot, orderBy, limit } from 'firebase/firestore'
import { getAuth, applyActionCode, sendEmailVerification } from 'firebase/auth'
import * as constant from '@/constant/constant.js'
const DOMAIN_NAME = constant.DEFAULT_DOMAIN_NAME
const db = getFirestore(firebaseApp)
const auth = getAuth(firebaseApp)

export default {
  components: {
    notifiedCard,
    modalWindow
  },
  props: [
    'hasNotifiedBar',
    'teamIdForBoard'
  ],
  data () {
    return {
      notifyListener: undefined, // 通知のlistener
      boardListener: undefined, // ボードのlistener
      teamId: null, // ボードを表示するteamId
      boardCards: [], // ボードのカード配列
      loginUserId: '', // ログインuserのuerId
      loginUserImageUrl: '',
      isAnonymous: false, // 匿名ユーザかどうかを判定
      enableDropdownBtn: false, // ドロップダウンメニューのクリック判定
      enableNotifiedBtn: false, // 通知ボタンにクリック判定
      hasSideColumn: false, // 通知用サイドカラム
      notifications: [], // 通知情報の配列
      notifiedLength: 0, // 通知情報の中でviewFlagがfalseの未読の通知の長さ
      hasNotifications: false, // 通知を持っているかどうか（v-bind:classのtrue/false使うため、notifiedLengthで代用できない)
      audio: new Audio(require('@/components/globals/header/sounds/notification.mp3')),
      isAdded: false, // listnerの変更がaddの場合にtureにして通知する
      isSmartPhone: true, // 画面サイズを判定する
      modalMsg: '',
      isEmailVerified: true, // メール認証が完了していればTrue
      isEmailResended: false // メール再送信したらTrue
    }
  },
  beforeDestroy () {
    this.notifyListener()
    this.boardListener()
  },
  mounted () {
    this.isSmartPhone = window.innerWidth < 768
  },
  methods: {
    async notifiedListener () {
      await this.getHeaderData()
      // 匿名ユーザならリターン
      if (this.isAnonymous) { return }
      // notificationsのlistenrを作る v9 Moduler
      const QUERY_NUM = 32
      const docRef = collection(db, 'uids/' + this.loginUserId + '/notifications')
      const q = query(docRef, orderBy('createdAt', 'desc'), limit(QUERY_NUM))
      this.notifyListener = onSnapshot(q, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          // 追加時
          if (change.type === 'added') {
            let temp = change.doc.data()
            temp.id = change.doc.id
            this.notifications.push(temp)
            this.isAdded = true
          }
          // 修正（既読によりview flagの更新時）
          if (change.type === 'modified') {
            let temp = change.doc.data()
            temp.id = change.doc.id
            const targetIndex = this.notifications.findIndex(({id}) => id === temp.id)
            if (targetIndex !== -1) { this.notifications.splice(targetIndex, 1) }
            this.notifications.push(temp)
          }
          // limitにより押し出される
          if (change.type === 'removed') {
            let temp = change.doc.data()
            temp.id = change.doc.id
            const targetIndex = this.notifications.findIndex(({id}) => id === temp.id)
            if (targetIndex !== -1) { this.notifications.splice(targetIndex, 1) }
          }
        })
        // 変化のみ取得により配列の順番がランダム化するのでcreatedAtで再ソートする
        this.notifications = sortArraybyCreatedAt(this.notifications)
        // 通知の数値系情報の取得
        ;[this.notifiedLength, this.hasNotifications] = getNotificationData(this.notifications)

        // 音を鳴らす
        if (this.isAdded && this.loginUserData.soundFlag) {
          this.audio.play()
          this.isAdded = false
        }
        // 通知のSideBarが有効ならデータを送る
        if (this.hasSideColumn) {
          const notificationsData = sortArraybyCreatedAt(this.notifications)
          this.$emit('showNotifiedBar', notificationsData, this.hasSideColumn)
        }
      })
    },
    async getHeaderData () {
      if (location.hostname !== DOMAIN_NAME) { console.log(`======== Header: getHeaderData() ========`) }
      this.enableDropdownBtn = false
      this.loginUserId = await getMyUserId()
      this.loginUserData = await getMyUserData(this.loginUserId)
      this.loginUserImageUrl = this.loginUserData.imageUrl
      this.isAnonymous = this.loginUserData.isAnonymous
      this.isEmailVerified = this.loginUserData.emailVerified
      // queryにメール認証コードが存在する
      if (this.$route.query.oobCode && this.$route.query.mode === 'verifyEmail') {
        // ログイン前ならリターン
        if (this.isAnonymous) { return }
        // ログイン済ならメール認証を走らせる
        await this.verifyEmail()
      }
    },
    async teamBoardListener () {
      // リスナーを貼る
      const cardsQuery = query(collection(db, 'teams/' + this.teamId + '/boards'))
      this.boardListener = onSnapshot(cardsQuery, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          // 追加時
          if (change.type === 'added') {
            let temp = change.doc.data()
            temp.id = change.doc.id
            if (!temp.isDeleted) {
              this.boardCards.push(temp)
            }
          }
          // 修正（更新時）
          if (change.type === 'modified') {
            let temp = change.doc.data()
            temp.id = change.doc.id
            const targetIndex = this.boardCards.findIndex(({id}) => id === temp.id)
            if (targetIndex !== -1) { this.boardCards.splice(targetIndex, 1) }
            this.boardCards.push(temp)
          }
          // 修正（削除時)
          if (change.type === 'modified' && change.doc.data().isDeleted) {
            let temp = change.doc.data()
            temp.id = change.doc.id
            const targetIndex = this.boardCards.findIndex(({id}) => id === temp.id)
            if (targetIndex !== -1) { this.boardCards.splice(targetIndex, 1) }
          }
          // 完全削除時
          if (change.type === 'removed') {
            let temp = change.doc.data()
            temp.id = change.doc.id
            const targetIndex = this.boardCards.findIndex(({id}) => id === temp.id)
            if (targetIndex !== -1) { this.boardCards.splice(targetIndex, 1) }
          }
        })
        // 変化のみ取得により配列の順番がランダム化するのでcreatedAtで再ソートする
        this.boardCards = sortArraybyCreatedAt(this.boardCards)
        this.$emit('sendBoardCard', this.boardCards)
      })
    },
    async verifyEmail () {
      if (location.hostname !== DOMAIN_NAME) { console.log(`======== Start to verify Email ========`) }
      this.modalMsg = ''
      const currentUser = auth.currentUser
      this.isEmailVerified = currentUser.emailVerified
      // すでに認証済
      if (this.isEmailVerified) {
        this.modalMsg = '認証が完了しました'
        Router.push({ path: '/editprofile' })
      }
      // 認証前の場合は認証処理を行う
      const actionCode = this.$route.query.oobCode
      if (actionCode && !currentUser.emailVerified) {
        // actionCodeを用いてメール認証を行う
        try {
          await applyActionCode(auth, actionCode)
          // メール認証を行ってもauthをreloadしないとUser情報が更新されないのでreloadする
          await auth.currentUser.reload()
          // firestore.rules側も更新されていないのでgetIdTokenでrefleshする
          await auth.currentUser.getIdToken(true)
          if (location.hostname !== DOMAIN_NAME) { console.log(`======== success to apply action code ========`) }
        } catch (error) {
          // 確認メールを一定時間クリックしないと無効化されてエラーになる
          this.modalMsg = 'メール認証に失敗しました'
          console.log(error)
        }
        try {
          const applyUser = auth.currentUser
          await getMyUserData(this.loginUserId)
          if (location.hostname !== DOMAIN_NAME) { console.log(`======== apply user is ========`) }
          if (location.hostname !== DOMAIN_NAME) { console.log(applyUser) }
          this.isEmailVerified = applyUser.emailVerified
          if (this.isEmailVerified) {
            this.modalMsg = '認証が完了しました'
            Router.push({ path: '/editprofile' })
          } else {
            this.modalMsg = 'メール認証が完了していません'
          }
        } catch (error) {
          this.modalMsg = 'メール認証に失敗しました'
          console.log(error)
        }
      }
    },
    async sendEmail () {
      this.modalMsg = ''
      await sendEmailVerification(auth.currentUser)
      this.modalMsg = '確認メールを再送しました'
    },
    switchEmailButton () {
      this.isEmailResended = !this.isEmailResended
    },
    showDropdown () {
      this.enableDropdownBtn = !this.enableDropdownBtn
      this.enableNotifiedBtn = false
    },
    showNotification () {
      this.enableNotifiedBtn = !this.enableNotifiedBtn
      this.enableDropdownBtn = false
    },
    closeModal () {
      this.enableNotifiedBtn = false
      this.enableDropdownBtn = false
    },
    async logout () {
      try {
        await signOutQnQ()
      } catch (error) {
        console.error(error)
      }
      location.reload(true)
    },
    didNotification (flag) {
      this.enableNotifiedBtn = flag
    },
    decreaseLength (flag) {
      if (flag) {
        this.notifiedLength -= 1
      }
      if (this.notifiedLength < 0) {
        this.notifiedLength = 0
      }
      this.hasNotifications = this.notifiedLength > 0
    }
  },
  computed: {
    IsLoggingIn () {
      return Store.getters.getIsLoggingIn
    }
  },
  watch: {
    hasNotifiedBar: function () {
      this.enableDropdownBtn = false
      this.hasSideColumn = this.hasNotifiedBar
      if (!this.hasNotifiedBar) { return }
      const notificationsData = sortArraybyCreatedAt(this.notifications)
      this.$emit('showNotifiedBar', notificationsData, this.hasSideColumn)
    },
    teamIdForBoard: async function () {
      // teamIdがnullならreturn
      if (!this.teamIdForBoard) { return }
      // teamIdが前回と同じならreturn
      if (this.teamIdForBoard === this.teamId) { return }
      // teamIdが異なる&&teamIdがnullでない場合は、過去のboardリスナーを一旦開放
      if (this.teamId) {
        // ボードの初期化
        this.boardListener()
        this.boardCards = []
      }
      // teamIdに新しいteamを入力
      this.teamId = this.teamIdForBoard
      // 新しいteamIdで再度listnerを貼る
      await this.teamBoardListener()
    },
    /**
    * Vue Router仕様
    * 同じrouteの異なるパラメータで画面遷移しても、vue-routerは画面を再描画しない（ライフサイクルフックが呼ばれない）
    * 別のrouteの場合が画面を再描画する
    * fromとtoのcomponant nameが異なる場合は、再描画が走るのでreturn
    * component nameが同じ場合、route prameterが別なら強制リロードして再描画
    */
    async $route (to, from) {
      // 初回読み込み：通知Listnerを貼る
      if (!from.name) {
        await this.notifiedListener()
      }
      // path変更時にはHeaderDataを初期化する
      if (from.name !== to.name) {
        // from.name = nullは初回起動なのでSKIP
        if (!from.name) {
          return
        }
        // 初回でない場合は、page切り替えの度にheader更新する
        await this.getHeaderData()
      }
      // Treeのnodeがclickされたケースで通知を更新
      if (to.name === 'Tree' && to.query.node) {
        let targetData = this.notifications.find((data) => data.targettedTreeId === to.params.treeId && data.number === Number(to.query.node))
        // 通知が存在しない場合はreturn
        if (!targetData) { return }
        // 通知が存在してもすでに閲覧済みならreturn
        if (targetData.view) { return }
        // 通知を更新
        targetData.viewFlag = true
        await updateNotification(targetData)
      }
    }
  }
}
</script>
<style scoped>
.navbar {
  min-height: 2.25rem;
}
.navbar-brand, .navbar-tabs {
  min-height: 2.25rem;
}
.navbar.is-link {
  background-color: #191970;
  color: #fff;
}
.navbar-item, .navbar-link {
  padding: 0.15rem 0.75rem;
}
.navbar-item img {
  max-height: 1.5rem;
}
.button.is-link {
  background-color: #191970;
}
.nav-end {
  justify-content: flex-end;
  margin-left: auto;
}
.item {
  padding: .5rem .5rem;
}
.navbar-brand {
  width: 95vw;
  max-width: 1024px;
  margin-left: auto;
  margin-right: auto;
}
.fa-stack .image{
  margin-left: 4px;
  margin-top: 4px;
}
.overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 700px) {
  .dropdown {
    display: grid;
    background-color: white;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-top: 2px solid #dbdbdb;
    box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1);
    font-size: 0.875rem;
    position:absolute;
    right: 5vw;
    top: 5vh;
    max-width: 80%;
    max-height: 70%;
    z-index: 50;
    overflow: auto;
    transition: min-height 0.5s;
    font-size: 0.6rem;
  }
}
@media screen and (max-width: 1023px) and (min-width: 701px) {
  .dropdown {
    display: grid;
    background-color: white;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-top: 2px solid #dbdbdb;
    box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1);
    font-size: 0.875rem;
    position:absolute;
    right: 5vw;
    top: 5vh;
    max-width: 50%;
    max-height: 60%;
    z-index: 50;
    overflow: auto;
    transition: min-height 0.5s;
    font-size: 0.8rem;
  }
}
@media screen and (min-width: 1024px) {
  .dropdown {
    display: grid;
    background-color: white;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-top: 2px solid #dbdbdb;
    box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1);
    font-size: 0.875rem;
    position:absolute;
    right: calc(50vw - 510px);
    top: 5vh;
    max-width: 50%;
    max-height: 60%;
    z-index: 50;
    overflow: auto;
    transition: min-height 0.5s;
    font-size: 0.8rem;
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/** スクロールバーのバーのとこ */
::-webkit-scrollbar-thumb {
  background: rgba(100,100,100, .6);
  border-radius: 3px;
}

/** スクロールバーの背景のとこ */
::-webkit-scrollbar-track {
  background: rgba(200,200,200, .6);
}

.dropdown .item {
  padding: 0.375rem 1rem;
  white-space: nowrap;
}
.dropdown a.item {
  padding-right: 3rem;
}
.dropdown a.item:focus, .dropdown a.item:hover {
  background-color: whitesmoke;
  color: #0a0a0a;
}
.dropdown a.item.is-active {
  background-color: whitesmoke;
  color: #3273dc;
}
.buttons .button:not(:last-child):not(.is-fullwidth) {
  margin-right: 0rem;
}
.side {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.side .button{
  margin-bottom: 0.0rem;
}
</style>
<template>
<div>
  <header class="header">
    <nav class="navbar is-fixed-top is-link" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <router-link class="navbar-item" to="/">
          <img src="@/assets/logo.png">
        </router-link>
        <router-link class="navbar-item" to="/about" v-if="isAnonymous">
          <a class="button is-link">
            <span class="icon">
              <i class="fa-solid fa-info-circle"></i>
            </span>
          </a>
        </router-link>
        <router-link class="navbar-item" to="/makeqnq" v-if="!isAnonymous">
          <a class="button is-link">
            <span class="icon">
              <i class="fa-solid fa-plus-square"></i>
            </span>
          </a>
        </router-link>
        <router-link class="navbar-item" v-bind:to="{ path: '/profile/' + this.loginUserId }" v-if="!isAnonymous">
          <a class="button is-link">
            <span class="icon">
              <i class="fa-solid fa-user"></i>
            </span>
          </a>
        </router-link>
        <div class="nav-end">
          <div class="navbar-item">
            <div class="buttons">
              <div class="bell">
                <a class="button" v-bind:class="{'is-link' : !hasNotifications, 'is-danger' : hasNotifications}" @click="showNotification()" v-if="!isAnonymous">
                  <span class="icon">
                    <i class="fa-solid fa-bell"></i>
                  </span>
                  <span>
                    {{notifiedLength}}
                  </span>
                </a>
                <div class="overlay" @click="closeModal" v-if="enableNotifiedBtn">
                  <div class="dropdown">
                    <notifiedCard
                      v-for="(data, index) in notifications"
                      v-bind:data="data"
                      v-bind:key="index"
                      @clickViewNotified="didNotification"
                      @decreaseNotifiedCount="decreaseLength"
                    />
                  </div>
                </div>
              </div>
              <a class="button is-link is-small" @click="showDropdown();" v-if="!isAnonymous">
                <span class="icon is-medium">
                  <span class="fa-stack">
                    <i class="fa-solid fa-circle fa-stack-2x has-text-white"></i>
                    <figure class="image is-16x16">
                      <img class="is-rounded" :src="loginUserImageUrl" alt="Placeholder image">
                    </figure>
                  </span>
                </span>
                <span class="icon">
                  <i class="fa-solid fa-sort-down"></i>
                </span>
              </a>
              <div class="overlay" @click="closeModal" v-if="enableDropdownBtn">
                <div class="dropdown">
                  <router-link class="item has-text-left" v-bind:to="{ path: '/profile/' + this.loginUserId }">
                    プロフィール
                  </router-link>
                  <router-link class="item has-text-left" to="/editprofile">
                    プロフィール設定
                  </router-link>
                  <router-link class="item has-text-left" to="/myteams">
                    チームの管理
                  </router-link>
                  <hr class="test is-marginless">
                  <router-link class="item has-text-left" to="/about">
                    QQについて
                  </router-link>
                  <hr class="test is-marginless">
                  <a class="item has-text-left" @click="logout()">
                    ログアウト
                  </a>
                </div>
              </div>
            </div>
            <router-link to="/login" v-if="isAnonymous">
              <a class="button is-link">
                <span class="icon">
                  <i class="fa-solid fa-user-plus"></i>
                </span>
                <span>
                  Sign-In
                </span>
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </nav>
  </header>
  <div v-if="IsLoggingIn===true" class="loading">
    <br>
    ログイン中...
    <progress class="progress is-link" max="100">30%</progress>
  </div>
  <div class="email-verified-modal-window">
    <modalWindow v-if="!isEmailVerified && !isAnonymous && (loginUserData.providerId === 'password')">
      <template slot="header">
        <div class="buttons is-right">
          <button class="delete"></button>
        </div>
      </template>
      <p>
        認証メールをお送りしました<br>
        認証メールのLINKをクリックしてメール認証をしてください<br>
        認証完了した場合は完了ボタンをクリックください<br>
      </p>
      <template slot="footer">
        <div class="buttons is-centered" @click="verifyEmail()" v-if="!isEmailResended">
          <button class="button is-link">認証完了</button>
        </div>
        <div class="buttons is-centered" @click="sendEmail()" v-else>
          <button class="button is-danger is-outlined">メールの再送</button>
        </div>
        <br>
        <a class="text has-text-centered is-underlined has-text-link" @click="switchEmailButton()">メールの再送が必要な方はこちら</a>
        <br>
        <p class="help is-danger has-text-centered">{{modalMsg}}</p>
      </template>
    </modalWindow>
  </div>
</div>
</template>



// WEBPACK FOOTER //
// src/components/globals/header/Header.vue